import { SetNewPasswordpage } from "./setNewPass.page";

export default SetNewPasswordpage;
